import { useTechDocsReaderPage } from '@backstage/plugin-techdocs-react';
import { Chip, Typography } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import { useExtendedTechDocsMetadata } from '../../../../hooks/useExtendedTechDocsMetadata';

export const PageTags = () => {
  const { entityRef } = useTechDocsReaderPage();
  const { '*': path = '' } = useParams();
  const { tags, isLoading } = useExtendedTechDocsMetadata(entityRef, path);
  if (isLoading) {
    return null;
  }
  return (
    <>
      <Typography component="h2">Tags</Typography>
      <Typography paragraph>
        {tags.length ? (
          tags.map(t => <Chip size="small" label={t} variant="outlined" />)
        ) : (
          <em>This page is not tagged.</em>
        )}
      </Typography>
    </>
  );
};
